<template>
  <PageWrap>
    <HeadSeo :data="data?.page" />
    <HomeHeader />
    <main>
      <ServiceList :data="data?.service" />
      <BlockWhyWe />
      <BlockProduction />
      <BlockProductionVideo />
      <BlockWasBecame
        before="/static/image/before.jpg"
        after="/static/image/after.jpg"
        title="Сравнените свет фар до и после наших работ"
      />
      <BlockArticleText :html="data?.page.text" :name="`page-${data?.page?.id}`" />
      <BlockProjectsList :data="data?.catalog" />
      <BlockAchievements />
      <BlockZakaz />
      <HomeNews :data="data?.news" />
      <BlockContact />
    </main>
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
const { data } = await useFetch("/api/home");
</script>
